module.exports = __webpack_public_path__ + "img/fitness-group.746ce257.jpg";